import baseComponent from "@/scripts/baseComponent";
import authApi from '@/api/common/auth';

export default {

    extends: baseComponent,

    props: {

    },

    data() {
        return {

        };
    },

    computed: {

    },

    created() {

    },

    mounted() {

    },

    methods: {

    }
} 